import React from "react";
import { Paper, Space, Tabs, Text } from "@mantine/core";
import { PageLayout } from "../../../components/layout";
import { ScfFundingIntroductionList } from "./list";
import { ScfFundingIntroductionSupplierList } from "../../../components/scf-funding-introduction/supplier-list";
import { useNavigate, useParams } from "react-router";
import { IconShoppingCart, IconTruckLoading } from "@tabler/icons";
import { useSelector } from "react-redux";
import { IAuth } from "../../../interfaces/IAuth";

export function ScfFundingIntroductionTabs() {
  const params = useParams();
  const navigate = useNavigate();
  const [tabKey, setTabKey] = React.useState<string | null>(params.type || "BUYER");
  const { user } = useSelector((state: { auth: IAuth }) => state.auth);

  const titles = (type: string) => {
    switch (type) {
      case "BUYER": {
        return "Buyer LED олголтын гүйлгээ";
      }
      case "SUPPLIER": {
        return "Supplier LED олголтын гүйлгээ";
      }
    }
  };

  const onChange = (value: string) => {
    navigate(`/scf/funding-instruction/${value}`);
    setTabKey(value);
  };

  const breadcrumbs = useBreadcrumb(titles(tabKey as string));

  return (
    <PageLayout
      title={tabKey === "BUYER" ? "Buyer LED олголтын гүйлгээний жагсаалт" : "Supplier LED олголтын гүйлгээний жагсаалт"}
      subTitle="Банк зөвшөөрсөн олгосон санхүүжилтийн гүйлгээ."
      breadcrumb={breadcrumbs}
      extra={[]}>
      <Paper radius="sm" p="md" withBorder>
        <Tabs value={tabKey} onTabChange={(e) => onChange(e as string)}>
          <Tabs.List>
            {(user?.permissions || []).filter((c) => c.module === "SCF" && c.code === "SCF_FUNDING_INSTRUCTION_MANAGEMENT_BL" && c.isView).length > 0 && (
              <Tabs.Tab value="BUYER" icon={<IconShoppingCart color={tabKey === "BUYER" ? "#3e166e" : "#44566C"} />}>
                <Text size="sm" weight={500} c="#44566C">
                  Buyer LED
                </Text>
              </Tabs.Tab>
            )}

            {(user?.permissions || []).filter((c) => c.module === "SCF" && c.code === "SCF_FUNDING_INSTRUCTION_MANAGEMENT_SL" && c.isView).length > 0 && (
              <Tabs.Tab value="SUPPLIER" icon={<IconTruckLoading color={tabKey === "SUPPLIER" ? "#3e166e" : "#44566C"} />}>
                <Text size="sm" weight={500} c="#44566C">
                  Supplier LED
                </Text>
              </Tabs.Tab>
            )}
          </Tabs.List>
          <Space h={10} />

          {(user?.permissions || []).filter((c) => c.module === "SCF" && c.code === "SCF_FUNDING_INSTRUCTION_MANAGEMENT_BL" && c.isView).length > 0 && (
            <Tabs.Panel value="BUYER">
              <ScfFundingIntroductionList />
            </Tabs.Panel>
          )}
          {(user?.permissions || []).filter((c) => c.module === "SCF" && c.code === "SCF_FUNDING_INSTRUCTION_MANAGEMENT_BL" && c.isView).length > 0 && (
            <Tabs.Panel value="SUPPLIER">
              <ScfFundingIntroductionSupplierList />
            </Tabs.Panel>
          )}
        </Tabs>
      </Paper>
    </PageLayout>
  );
}

const useBreadcrumb = (type: any) => [
  {
    to: "/",
    label: "Үндсэн",
  },
  {
    label: "SCF санхүүжилт",
  },
  {
    label: type,
  },
];
